import ResetPasswordGeneric from '../ResetPasswordGeneric';

export default function ResetPasswordLavoratore() {
    return (
        <ResetPasswordGeneric
            apiEndpoint="/area-medico/reset-password"
            titolo="Username medico"
            loginUrl="/AreaMedico/Login"
        />
    );
}
